import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "vue-video" }
const _hoisted_2 = { class: "vue-video-box" }

import { onMounted, ref } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import { LabData } from '@/types/LabData';
import RecentCard from '@/components/Carousel/RecentCard.vue';
import VideoCard from '@/components/Carousel/VideoCard.vue';
import { MediaFile } from '@/types/manuals';
import CarouselPagination from '@/components/Carousel/CarouselPagination.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselVideoCards',
  props: {
    list: {},
    isVideo: { type: Boolean }
  },
  setup(__props: any) {



const currentSlide = ref(0);
const carouselRef = ref();
const paginationRef = ref();
const breakpoints = ref();

onMounted(() => {
  breakpoints.value = {
    // 320 and up
    320: {
      itemsToShow: carouselRef.value.data.maxSlide.value > 0 ? 1.25 : 1,
      snapAlign: 'start',
    },
    480: {
      itemsToShow: carouselRef.value.data.maxSlide.value > 0 ? 2.25 : 2,
      snapAlign: 'start',
    },
    961: {
      itemsToShow: 3,
      snapAlign: 'start',
    },
  };
});

const slideEnd = () => {
  paginationRef.value.updVisibleCards();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Carousel), {
        ref_key: "carouselRef",
        ref: carouselRef,
        modelValue: currentSlide.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event)),
        breakpoints: breakpoints.value,
        onSlideEnd: slideEnd
      }, {
        addons: _withCtx(() => [
          _createVNode(_unref(Navigation))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (card, index) => {
            return (_openBlock(), _createBlock(_unref(Slide), {
              key: index,
              class: "slideEl"
            }, {
              default: _withCtx(() => [
                (_ctx.isVideo)
                  ? (_openBlock(), _createBlock(VideoCard, {
                      key: 0,
                      card: card as MediaFile,
                      class: "carousel__slide"
                    }, null, 8, ["card"]))
                  : (_openBlock(), _createBlock(RecentCard, {
                      key: 1,
                      card: card as LabData,
                      class: "carousel__slide"
                    }, null, 8, ["card"]))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "breakpoints"])
    ]),
    _createVNode(CarouselPagination, {
      ref_key: "paginationRef",
      ref: paginationRef,
      carouselRef: carouselRef.value
    }, null, 8, ["carouselRef"])
  ]))
}
}

})